import React from 'react';
import ReactPlayer from 'react-player';
import '../../pages/Evaluations.css';

interface SingleFileViewerProps {
  /** Competition type: video | pdf | html | github; anything else renders as an image. */
  type?: string;
  url: string;
  label: string;
  onImageClick?: (url: string) => void;
}

const SingleFileViewer: React.FC<SingleFileViewerProps> = ({ type, url, label, onImageClick }) => {
  const kind = (type || '').toLowerCase();
  return (
    <div className="evaluations-image-card">
      <div className="evaluations-image-label">{label}</div>
      {kind === 'video' ? (
        <div className="evaluations-video-wrapper">
          <ReactPlayer
            src={url}
            controls
            width="100%"
            height="100%"
            className="evaluations-video-player"
          />
        </div>
      ) : kind === 'pdf' ? (
        <>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="evaluations-pdf-link"
          >
            📄 Open PDF in new tab
          </a>
          <div className="evaluations-pdf-wrapper">
            <iframe
              src={url}
              title={`${label}`}
              className="evaluations-pdf-viewer"
            />
          </div>
        </>
      ) : kind === 'html' ? (
        <>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="evaluations-pdf-link"
          >
            Open URL in new tab
          </a>
          <div className="evaluations-pdf-wrapper evaluations-html-wrapper">
            <iframe
              src={url}
              title={`${label}`}
              className="evaluations-pdf-viewer"
            />
          </div>
        </>
      ) : kind === 'github' ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="evaluations-pdf-link"
        >
          Open GitHub repo in new tab
        </a>
      ) : (
        <img
          src={url}
          alt={`${label}`}
          className="evaluations-image"
          onClick={() => onImageClick?.(url)}
        />
      )}
    </div>
  );
};

export default SingleFileViewer;
